// tense("will take", "took"): the present (or future) wording until the event is over, then the
// past. pastOrEnd: true/false, or the event's last day ("2026-04-17"), which switches by itself
// the day after (Seán, 2026-10-27)
function getIsPast(pastOrEnd) {
  if (typeof pastOrEnd !== "string") return Boolean(pastOrEnd);
  return new Date() > new Date(`${pastOrEnd}T23:59:59`);
}

export default function useTense(pastOrEnd) {
  const isPast = getIsPast(pastOrEnd);
  const tense = (present, past) => (isPast ? past : present);
  return {tense, isPast};
}
